var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTraining(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141.7 147.6",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.79,100.85a18,18,0,0,1-17.69,0L21,76.28s-3.61-2.21-3.61,2.81v24.53c0,12.92,23.51,26.85,52.51,26.85s52.51-13.93,52.51-26.85V77.71c0-4-2.57-2.07-2.57-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,56.75c3.08-1.89,3.08-5,0-6.87l-61-30.51a11.75,11.75,0,0,0-11.19,0l-61,30.51c-3.07,1.89-3.07,5,0,6.87l61,37.42a11.81,11.81,0,0,0,11.19,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,112.21V70.88s0-1.95-1.13-1.31a32.91,32.91,0,0,0-4,2.49c-.93.81-.72,2.62-.72,2.62v37.53a1.12,1.12,0,0,1-.68.92,7.13,7.13,0,1,0,7.2,0A1.06,1.06,0,0,1,134,112.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.8fb3a842ee33e3b0d2e919e23f5e03cb.svg";
export { ForwardRef as ReactComponent };